import { useEffect } from 'react';
import { isOfflineEnabled } from '../../db/odin-db-util';
import { useAppDispatch } from '../hooks';
import { aiApi } from '../services/ai-api';
import { api } from '../services/api';
import { hierarchyApi } from '../services/hierarchy';
import { moduleApi } from '../services/module';
import { recordApi } from '../services/record';
import { recordListMenuApi } from '../services/record-list-menu';

const usePrefetchLayoutData = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!isOfflineEnabled) {
      return;
    }

    // prefetch my activities, to allow home page to load faster
    dispatch(recordApi.util.prefetch('getMyActivities', { page: 1, pageSize: 50 }, { force: true }));

    // prefetch modules and forms data
    dispatch(moduleApi.util.prefetch('modules', {}, { force: true }));
    dispatch(moduleApi.util.prefetch('modules', { includeFormList: true }, { force: true }));

    // prefetch misc data
    dispatch(hierarchyApi.util.prefetch('hierarchyTypes', { archived: 'false' }, { force: true }));
    dispatch(recordListMenuApi.util.prefetch('getPinnedRecordListMenuItems', undefined, { force: true }));
    dispatch(aiApi.util.prefetch('getAIMetadata', undefined, { force: true }));
    dispatch(api.util.prefetch('getMetaData', undefined, { force: true }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export default usePrefetchLayoutData;
